import styled, { css } from "styled-components";
import { rgba, colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const LegendItemContainer = styled.div<{ gridDirection: string }>`
    display: flex;
    flex-direction: ${({ gridDirection }) => gridDirection};
    justify-content: space-between;
`;

export const LegendItemTextContainer = styled(FlexRow)``;

export const NonSelectableLegendWrapper = styled.div<{ presentLegendNextToGraph: boolean }>`
    width: auto;
    display: flex;
    ${({ presentLegendNextToGraph }) =>
        presentLegendNextToGraph
            ? css`
                  flex-direction: column;
                  gap: 8px;
              `
            : css`
                  flex-direction: row;
              `}
`;

export const LabelName = styled.div`
    ${setFontVariant("body2", rgba(colorsPalettes.carbon[500], 0.8))};
`;

export const LabelValue = styled.div<{ largeFont?: boolean }>`
    margin-left: 20px;
    font-size: 24px;
    ${({ largeFont }) =>
        largeFont
            ? css`
                  ${setFontVariant("input1", colorsPalettes.carbon[500])}
              `
            : css`
                  ${setFontVariant("input2", colorsPalettes.carbon[300])}
              `}
`;

export const StyledBasicLegendWrapper = styled.span`
    .winnerIcon {
        padding-top: 0;
        margin-left: auto;
    }

    > div {
        > div {
            width: 100%;
        }
        > label {
            padding-left: 16px;
            overflow: visible;
        }
    }
`;

export const Circle = styled.span`
    border-radius: 50%;
    text-align: center;
    ${({ color }) => `background-color:${color};`};
    width: 10px;
    height: 10px;
    margin-right: 9px;
    margin-top: 2px;
    align-self: center;
`;
export const StyledLegendWithValuesWrapper = styled.span`
    min-width: 150px;
    ${StyledBasicLegendWrapper};
`;

export const DynamicItemLegendContainer = styled.div`
    .legend-text-container {
        align-items: center;
    }
`;

export const DynamicItemLegendTextContainer = styled(FlexRow)``;

export const DynamicItemLegendDropDownContainer = styled.div`
    margin: 0 -4px 0 8px;
`;

export const DynamicItemLegendDropDownButton = styled(FlexRow)``;

export const DynamicItemLegendSingleItemTextContainer = styled.div`
    margin-right: 4px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;

export const DynamicItemLegendText = styled.span`
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 70px;
    overflow: hidden;
    ${setFontVariant("listItem1", colorsPalettes.carbon[400])};
`;

export const DynamicItemLegendDropDownButtonIcon = styled.div`
    margin: 0 8px;
`;

export const SelectableLegendsWrapper = styled.div`
    padding-left: 5px;
    padding-top: 1px;
`;

export const LegendsDropDownWrapper = styled.div`
    padding-bottom: 20px;
`;
